import * as React from "react";
import { Maximize2 } from "lucide-react";

interface Props {
  artefactId: string;
  onExpand: (artefactId: string) => void;
}

export const ExpandButton: React.FC<Props> = ({ artefactId, onExpand }) => (
  <button
    type="button"
    onClick={() => onExpand(artefactId)}
    className="inline-flex items-center rounded px-1.5 py-0.5 text-xs text-muted-foreground transition-colors hover:bg-desert-sand-100 hover:text-foreground"
    title="Open in side panel"
  >
    <Maximize2 size={14} />
  </button>
);
